import { useRef } from "react";
import * as DialogPrimitive from "@radix-ui/react-dialog";
import { X } from "lucide-react";

/* Ventana flotante compartida (ficha PDF y video): foco atrapado, ESC, clic fuera y scroll bloqueado vía Radix. */
export function MediaModal({ open, onClose, title, children, contentClassName = "", contentStyle, testId }) {
  const opener = useRef(null);
  if (open && !opener.current && typeof document !== "undefined") opener.current = document.activeElement;
  function restoreFocus(e) {
    e.preventDefault();
    const el = opener.current;
    opener.current = null;
    el?.focus?.();
  }
  return (
    <DialogPrimitive.Root open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogPrimitive.Portal>
        <DialogPrimitive.Overlay className="fixed inset-0 z-50 bg-black/80 data-[state=open]:animate-in data-[state=open]:fade-in-0" />
        <DialogPrimitive.Content
          aria-describedby={undefined}
          onCloseAutoFocus={restoreFocus}
          className={`fixed left-1/2 top-1/2 z-50 flex -translate-x-1/2 -translate-y-1/2 flex-col overflow-hidden rounded-md shadow-2xl focus:outline-none data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95 ${contentClassName}`}
          style={contentStyle}
          data-testid={testId}
        >
          <DialogPrimitive.Title className="sr-only">{title}</DialogPrimitive.Title>
          {children}
          <DialogPrimitive.Close
            className="absolute right-2 top-2 z-20 flex h-10 w-10 items-center justify-center rounded-full bg-white text-[#3E5641] shadow-md hover:bg-[#F1F3F3] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#C4674F]"
            aria-label="Cerrar" data-testid={`${testId}-close`}
          >
            <X size={20} />
          </DialogPrimitive.Close>
        </DialogPrimitive.Content>
      </DialogPrimitive.Portal>
    </DialogPrimitive.Root>
  );
}

export function ModalSpinner({ label, testId }) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 py-16 text-sm text-[#6B7678]" data-testid={testId} role="status">
      <span className="h-8 w-8 animate-spin rounded-full border-2 border-[#C4674F]/30 border-t-[#C4674F]" />
      {label}
    </div>
  );
}
